import { queryParamHookFactory } from '../modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from '../modules/taboola-common-frontend-modules/storage';

const usePlatformInner = queryParamHookFactory('platform', { persist: PERSISTENCE_TYPE.MEMORY });

export const usePlatform = () => {
    const [platform] = usePlatformInner();
    return platform;
};
